<template>
  <div :class="prefixCls" style="position: relative">
    <!-- <div class="colorPicker">
            <span class="span">新增字体颜色：</span>
            <el-color-picker class="customColor" size="medium" v-model="color" @change="changeColor"></el-color-picker>
        </div> -->
    <!-- <el-input class="colorInput" type="text" placeholder="请输入16进制色值" v-model.trim="color">
            <i slot="prefix" class="">#</i>
            <template slot="append">
                <div style="width: 100%; padding: 0 10px;" @click="changeColor">
                    <i class="el-icon-check"></i>
                </div>
            </template>
        </el-input> -->
    <div ref="editor" class="editor-wrapper"></div>
  </div>
</template>

<script>
import WEditor from "wangeditor";
import apiEnv from "@/service/apiEnv.js";
var Editor = null;
export default {
  name: "Editor",
  props: {
    prefixCls: {
      type: String,
      default: "my-editor",
    },
    // eslint-disable-next-line
    value: {
      type: String,
      default: "",
    },
    isClear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      color: "",
      editorContent: null,
      flag: false,
      colors: ["#000000", "#eeece0", "#1c487f", "#4d80bf"],
      url: apiEnv.uploadURL,
    };
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        Editor.txt.clear();
        this.editorContent = null;
      }
    },
    value: {
      handler: function (val, oldVal) {
        if (val && !this.flag) {
          this.editorContent = val;
          // editor.txt.html(val);
          // this.flag = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.initColor();
    // this.setText(this.value);
    // document.getElementsByClassName('customColor')[0].addEventListener('click', this.handleClick);
  },
  methods: {
    handleClick() {
      console.log(
        "el-color-dropdown",
        document.getElementsByClassName("el-color-dropdown")
      );
    },
    initColor() {
      this.initEditor();
    },
    changeColor() {
      let color = this.color;
      // 视频为空，则不插入
      if (!(color && /^#([0-9a-zA-Z]{3}|[0-9a-zA-Z]{6})$/.test(color))) {
        this.$message({
          type: "warning",
          showClose: true,
          duration: 3000,
          message: "请输入16进制色值",
        });
        return;
      }
      this.initColor();
    },
    getText() {
      return Editor.txt.text();
    },
    setText(val) {
      Editor.txt.html(val);
    },

    initEditor() {
      Editor = new WEditor(this.$refs.editor);
      Editor.config.showMenuTooltips = true;
      Editor.config.menuTooltipPosition = "up";
      Editor.config.height = 364;
      Editor.config.placeholder = "";
      // 配置菜单 可根据文档进行添加
      Editor.config.menus = [
        "head",
        "bold",
        "fontSize",
        "fontName",
        "italic",
        "underline",
        "strikeThrough",
        "indent",
        "lineHeight",
        "foreColor",
        "backColor",
        "link",
        "list",
        "todo",
        "justify",
        "quote",
        "image",
        "video",
        "table",
        "code",
        "splitLine",
        "undo",
        "redo",
      ];
      Editor.config.fontSizes = {
        "x-small": { name: "12px", value: "1" },
        small: { name: "13px", value: "2" },
        normal: { name: "18px", value: "3" },
        large: { name: "20px", value: "4" },
        "x-large": { name: "24px", value: "5" },
        "xx-large": { name: "32px", value: "6" },
        "xxx-large": { name: "48px", value: "7" },
      };
      Editor.config.colors = this.colors;

      Editor.config.lineHeights = ["1", "1.15", "1.6", "2", "2.5", "3"];

      // 创建富文本编辑器
      Editor.config.onchange = (html) => {
        let str = html;
        str = str.replace(/\bm.*?;/, "width:300px"); //更改插入到富文本里图片的宽度
        this.editorContent = str;
        this.$emit("change", this.editorContent); // 将内容同步到父组件中
      };
      Editor.config.zIndex = 2; // 配置富文本的权重 不然会覆盖其他组件

      Editor.txt.html(this.editorContent);
      Editor.config.uploadImgShowBase64 = false; // base 64 存储图片
      Editor.config.showLinkImg = false; //关闭通过图片地址添加图片
      Editor.config.uploadImgServer = this.url; //如果需要本地上传图片 需配置上传图片服务器地址 找后端要
      Editor.config.uploadImgHeaders = {}; // 自定义 header
      Editor.config.uploadFileName = "file"; // 后端接受上传文件的参数名
      Editor.config.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
      Editor.config.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      Editor.config.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间

      Editor.create();
      // editor.config.emotions = [
      //     {
      //         // tab 的标题
      //         title: "默认",
      //         // type -> 'emoji' / 'image'
      //         type: "image",
      //         // content -> 数组//自定义表情根据文档 自行添加
      //         content: [
      //             {
      //                 alt: "[微笑]",
      //                 type: "face",
      //                 src:
      //                     "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/e3/2018new_weixioa02_org.png"
      //             },
      //             {
      //                 alt: "[可爱]",
      //                 type: "face",
      //                 src:
      //                     "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/09/2018new_keai_org.png"
      //             },
      //             {
      //                 alt: "[空星]",
      //                 src:
      //                     "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/ff/hot_blankstar_org.png"
      //             }
      //         ]
      //     },
      //     {
      //         // tab 的标题
      //         title: "emoji",
      //         // type -> 'emoji' / 'image'
      //         type: "emoji",
      //         // content -> 数组 自定义表情根据文档 自行添加
      //         content: [
      //             "😀",
      //             "😃",
      //             "😄",
      //             "😁",
      //             "😆",
      //             "🤣",
      //             "😄",
      //             "😅",
      //             "😆",
      //             "😉",
      //             "😊",
      //             "😋",
      //             "😎",
      //             "😍",
      //             "😘",
      //             "😗",
      //             "😚",
      //             "🙂",
      //             "🤗",
      //             "🤔",
      //             "😳",
      //             "😑",
      //             "😶",
      //             "🙄",
      //             "😏",
      //             "😣",
      //             "😥",
      //             "😮",
      //             "🤐",
      //             "😯",
      //             "😪",
      //             "😫",
      //             "😴",
      //             "😌",
      //             "😛",
      //             "😜",
      //             "😒",
      //             "😓",
      //             "😕",
      //             "🙃",
      //             "😲",
      //             "🙁",
      //             "😖",
      //             "😤",
      //             "😭",
      //             "😨",
      //             "😬",
      //             "😱",
      //             "😡",
      //             "😠",
      //             "😷",
      //             "🤒",
      //             "🤧",
      //             "🤡",
      //             "😈",
      //             "💀",
      //             "👻",
      //             "👽",
      //             "💩",
      //             "😺",
      //             "😸",
      //             "😹",
      //             "😻",
      //             "😼",
      //             "😽",
      //             "🙀",
      //             "😿",
      //             "😾",
      //             "💖",
      //             "💗",
      //             "💟",
      //             "💤",
      //             "💢",
      //             "👈",
      //             "👉",
      //             "☝",
      //             "👆",
      //             "✌",
      //             "👌",
      //             "👍",
      //             "👌",
      //             "👎",
      //             "✊",
      //             "🤛",
      //             "🤜",
      //             "👏",
      //             "🙏",
      //             "🤝",
      //             "🌹",
      //             "🥀"
      //         ]
      //     }
      // ];

      Editor.config.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
          console.log(xhr, editor, result);
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
          console.log(xhr, editor, result);
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
          console.log(xhr, editor);
        },
        error: (xhr, editor) => {
          // 图片上传错误的回调
          console.log(xhr, editor);
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功，插入图片的回调
          // result为上传图片成功的时候返回的数据，这里我打印了一下发现后台返回的是result.data：[{"路径的形式"},...]
          // console.log('result.data[0].url', result.data[0].url)
          // insertImg()为插入图片的函数
          // 循环插入图片
          console.log(editor);
          for (let i = 0; i < 1; i++) {
            console.log("result", result); // 根据格式来赋值
            const src = result.Data[0].imgUrl; // 如果返回的是完整的src就不用拼接 !!!!这里需要注意
            insertImg(src);
          }
        },
      };
      // 单个注册菜单
      // 将菜单加入到 editor.config.menus 中    const menuKey = 'alertMenuKey'
      // 也可以通过配置 menus 调整菜单的顺序，参考【配置菜单】部分的文档
      // Editor.config.menus.push(menuKey)
      // Editor.menus.extend(menuKey, PanelMenu)
      // Editor.config.menus = editor.config.menus.push(menuKey)
    },
  },
};
</script>

<style lang="scss">
.customColor {
}
.w-e-toolbar .w-e-droplist ul.w-e-block {
  list-style: none;
  text-align: left;
  padding: 5px;
  overflow-y: auto !important;
  height: 300px !important;
}

.w-e-menu-tooltip {
  position: absolute;
  display: flex;
  color: #f1f1f1;
  background-color: rgba(0, 0, 0, 0.75);
  // box-shadow: 0 2px 8px 0 rgb(0 0 0 / 15%);
  border-radius: 4px;
  padding: 1px 5px 1px !important;
  justify-content: center !important;
  line-height: 25px !important;
  align-items: flex-end !important;
  top: -28px !important;
}
font[size="1"] {
  font-size: 12px;
}
font[size="3"] {
  font-size: 18px;
}
font[size="4"] {
  font-size: 20px;
}
</style>
<style lang="scss" scoped>
.my-editor {
  .editor-wrapper {
    text-align: left;
  }
}
.colorInput {
  position: absolute;
  top: 1px;
  z-index: 999;
  width: 200px;
  right: 0;
}
.colorPicker {
  position: absolute;
  top: 3px;
  z-index: 999;
  // width: 50px;
  right: 3px;
  .span {
    display: inline-block;
    margin-right: 5px;
  }
}
::v-deep .el-input-group__append {
  padding: 0;
}
::v-deep .el-input__prefix {
  top: 11px;
  left: 11px;
}
::v-deep .w-e-text {
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
    box-shadow: none;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 6px;
    padding: 2px;
    box-shadow: none;
    background: rgba(229, 229, 229, 1);
  }

  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    box-shadow: none;
    background: transparent;
  }
}
</style>